module.exports = __webpack_public_path__ + "static/media/app.6261289d.svg";